if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
}

function page_load(collection_grid) {
    var back_col_html = localStorage.getItem('back_col_html');
    var back_col_url = localStorage.getItem('back_col_url');
    var back_col_next_url = localStorage.getItem('back_col_next_url');

    if (back_col_url == window.location.href) {
        collection_grid.innerHTML = back_col_html;
        collection_grid.setAttribute('data-next-url', back_col_next_url);
        if (collection_grid.getAttribute('data-next-url') == '') {
            const load_button_container = document.querySelector(".custom-filter-load-more");
            if (load_button_container) {
                load_button_container.style.display = 'none'
            }
        }
    }

    document.addEventListener('click', function(event) {

        const product_card = event.target.closest('.product-card');
        if (product_card) {
            localStorage.setItem('back_col_html', collection_grid.innerHTML);
            localStorage.setItem('back_col_url', window.location.href);
            localStorage.setItem('back_col_next_url', collection_grid.getAttribute('data-next-url'));
        }
    });
}

page_load(document.querySelector('.collection-grid'));


//window.history.scrollRestoration = "manual";
const STORAGE_KEY_ORIG = "collection-original-scroll-y";
const HISTORY_LOCATION = "history-last-scrolled-collection";
const cardLinks = document.querySelectorAll(
    ".collection-grid .product-card a"
);

document.addEventListener('click', function(event) {

    const product_card = event.target.closest('.product-card');
    let scrollOffset = window.scrollY || window.pageYOffSet;
    if (product_card) {
        sessionStorage.setItem(STORAGE_KEY_ORIG, scrollOffset );
        sessionStorage.setItem(HISTORY_LOCATION, window.location.href);
    }
});

function collectionHistoryBack() {
    if (sessionStorage.getItem(HISTORY_LOCATION) == window.location.href) {
        const scroll_curr_y = sessionStorage.getItem(STORAGE_KEY_ORIG) || 0;
        if (sessionStorage.getItem(STORAGE_KEY_ORIG)) {
            window.scrollTo({
                top: scroll_curr_y,
                left: 0,
                behavior: "instant",
            });
        }
    }
    document.querySelectorAll('.product-card .swiper').forEach((node)=>{
        new window.swiper(node, {
            navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            },
            spaceBetween: 10,
            cssMode: true,
            noSwiping: true,
            noSwipingClass: 'swiper-slide',
        })
    })
}
window.addEventListener("load", collectionHistoryBack);

function chainEventListeners() {
    const removeItems = () => {
        sessionStorage.removeItem(STORAGE_KEY_ORIG);
        sessionStorage.removeItem(HISTORY_LOCATION);
    };

    window.addEventListener("mousewheel", removeItems);
    window.addEventListener("touchstart", removeItems);
}

chainEventListeners();

document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.product-card .swiper:not(.swiper-initialized)').forEach((node)=>{
        new window.swiper(node, {
            navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            },
            spaceBetween: 10,
            cssMode: true,
            noSwiping: true,
            noSwipingClass: 'swiper-slide',
        })
    })

    // Load more products

    const load_btn = document.querySelector(".custom-filter-load-more");

    let products_on_page = document.querySelector('.collection-grid');

    let url = products_on_page.getAttribute('data-next-url');

    const spinner = document.querySelector('.load-more-spinner');

    if (load_btn) {

        if (url === '') {
            load_btn.style.display = 'none';
        }
        else{
            window.paginate_overflow_buffer = window.paginate_overflow_buffer || []
            if(products_on_page.querySelectorAll('.count-for-pagination').length % 6 != 0){
                Array.from(products_on_page.querySelectorAll('.hideable')).reverse().forEach((item)=>{
                    if(products_on_page.querySelectorAll('.count-for-pagination').length % 6 != 0){
                        window.paginate_overflow_buffer.push(item)
                        item.remove()
                    }
                })
            }
        }

        load_btn.addEventListener("click", () => {

            window.paginate_overflow_buffer = window.paginate_overflow_buffer || []

            spinner.classList.add("show");

            fetch(url)
                .then(function(response) {
                    if (response.ok) {
                        return response.text();
                    } else {
                        throw new Error('Network response was not ok.');
                    }
                })
                .then(function(data) {
                    const html = document.createElement('div');
                    html.innerHTML = data;

                    let links = html.querySelector('.pagination-links').innerHTML;
                    document.querySelector('.pagination-links').innerHTML = links;

                    let new_grid = html.querySelector('.collection-grid');
                    url = new_grid.getAttribute('data-next-url');
                    document.querySelector('.collection-grid').setAttribute('data-next-url',url)
                    if (url === '') {
                        load_btn.style.display = 'none';
                    }
                    //let new_products = new_grid.querySelectorAll(".product-card, #collection-grid-cta, #collection-grid-cta-2");
                    let new_products = new_grid.querySelectorAll(".product-card");

                    while(window.paginate_overflow_buffer.length > 0){
                        products_on_page.append(window.paginate_overflow_buffer.shift())
                    }

                    new_products.forEach(new_prod => {
                        products_on_page.append(new_prod);
                    });

                    if (url !== '') {
                        if(products_on_page.querySelectorAll('.count-for-pagination').length % 6 != 0){
                            Array.from(products_on_page.querySelectorAll('.hideable')).reverse().forEach((item)=>{
                                if(products_on_page.querySelectorAll('.count-for-pagination').length % 6 != 0){
                                    window.paginate_overflow_buffer.push(item)
                                    item.remove()
                                }
                            })
                        }
                    }
                    document.querySelectorAll('.product-card .swiper:not(.swiper-initialized)').forEach((node)=>{
                        new window.swiper(node, {
                            navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                            },
                            spaceBetween: 10,
                            cssMode: true,
                            noSwiping: true,
                            noSwipingClass: 'swiper-slide',
                        })
                    })
                    spinner.classList.remove("show");
                    document.dispatchEvent(new CustomEvent('pagination-done'))
                })
                .catch(function(error) {
                    window.log(error);
                });


        })
    }

    const rangeInput = document.querySelectorAll(".range-input input");
    if (rangeInput) {
        const priceInput = document.querySelectorAll(".price-input-show");
        const range = document.querySelector(".slider .progress");
        const minFilterInput = document.querySelector('.min-price-filter');
        const maxFilterInput = document.querySelector('.max-price-filter');
        let priceGap = 1;

        if (maxFilterInput) {
            range.style.left = ((minFilterInput.value / rangeInput[0].max) * 100) + "%";
            range.style.right = 100 - (maxFilterInput.value / rangeInput[1].max) * 100 + "%";
            rangeInput[0].value = minFilterInput.value;
            rangeInput[1].value = maxFilterInput.value;
            priceInput[0].innerHTML = minFilterInput.value;
            priceInput[1].innerHTML = maxFilterInput.value;
        }

        priceInput.forEach(input => {
            input.addEventListener("input", e => {
                let minPrice = parseInt(priceInput[0].innerHTML);
                let maxPrice = parseInt(priceInput[1].innerHTML);

                if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max) {
                    if (e.target.className === "input-min") {
                        rangeInput[0].value = minPrice;
                        rangeInput[0].setAttribute("data-term", minPrice);
                        range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
                    } else {
                        rangeInput[1].value = maxPrice;
                        maxFilterInput.value = maxVal;
                        range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                    }
                }
            });
        });

        rangeInput.forEach(input => {
            input.addEventListener("input", e => {
                let minVal = parseInt(rangeInput[0].value),
                    maxVal = parseInt(rangeInput[1].value);

                if ((maxVal - minVal) < priceGap) {
                    if (e.target.className === "range-min") {
                        rangeInput[0].value = maxVal - priceGap
                    } else {
                        rangeInput[1].value = minVal + priceGap;
                    }
                } else {
                    priceInput[0].innerHTML = minVal;
                    priceInput[1].innerHTML = maxVal;
                    range.style.left = ((minVal / rangeInput[0].max) * 100) + "%";
                    range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
                    minFilterInput.value = minVal;
                    maxFilterInput.value = maxVal;
                }
            });
        });
    }


    let custom_filters = document.querySelectorAll(".custom-filter")

    custom_filters.forEach((el) => {

        let control = el.querySelector(".filter-heading")
        let body = el.querySelector(".filter-body")

        if (control && body) {

            control.addEventListener('click', () => {

                if (el.classList.contains("open")) {
                    el.classList.remove("open")
                } else {
                    el.classList.add("open")
                }

            })
        }
    })

    let mobile_control = document.querySelector(".mobile-filter-heading");
    let filter_body = document.querySelector(".custom-filter-wrapper");

    if (mobile_control && filter_body) {
        mobile_control.addEventListener('click', () => {
            document.querySelector(".mobile-filter-heading h2").innerHTML = "Hide Filters & Sort";
            var source = document.querySelector(".filters_contents");
            document.querySelector(".collection-grid-wrapper").prepend(source);
            document.querySelector(".cta1").classList.add("adjust_cta1");
            document.querySelector(".collection-grid-wrapper").classList.add("plp_open_filter");
            document.querySelector(".filter-container-wrapper").classList.add("filter_open");
            document.querySelector(".filter-container-wrapper").classList.remove("plp_filter_start");
            document.querySelector(".collection-grid").classList.add("shift_right");

            //document.getElementById("collection-grid-cta").style.display = "none";
            // rotate svg
            if (mobile_control.classList.contains("open")) {
                mobile_control.classList.remove("open")
            } else {
                mobile_control.classList.add("open");
            }

            // open filters
            if (filter_body.classList.contains("open")) {
                filter_body.classList.remove("open");
                document.querySelector(".mobile-filter-heading h2").innerHTML = "Show Filters & Sort";
                document.querySelector(".collection-grid-wrapper").classList.remove("plp_open_filter");
                document.querySelector(".filter-container-wrapper").classList.remove("filter_open");
                document.querySelector(".filter-container-wrapper").classList.add("plp_filter_start");
                document.querySelector(".cta1").classList.remove("adjust_cta1");
                //document.querySelector(".filter-container-wrapper").style.display = "red";
            } else {
                filter_body.classList.add("open")
            }
        })
    }

    // Hide reset filters when no filters active
    const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');

    if (selected_filters_html.length > 0) {
        reset_filters.style.display = 'block';
    }

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            collection_grid.classList.add("loading")
        })
    })

    // Submit form on input change

    // const filter_inputs = document.querySelectorAll('.filter-container-wrapper select, .filter-container-wrapper input');
    // const filter_form = document.querySelector('.filter-container');
    // const reset_filter = document.querySelector('#reset-filters');
    // const collection_grid = document.querySelector('.collection-grid');

    // filter_inputs.forEach(input => {
    //     input.addEventListener('change', () => {
    //         ///collection_grid.classList.add("loading")
    //         //filter_form.submit()
    //     })
    // })

    // reset_filter.addEventListener('click', () => {
    //     collection_grid.classList.add("loading")
    // })

    // const filter_submit_btn = document.querySelectorAll('#submit_filters');
    // const reset_filter_btn = document.querySelector('#clear_filters');

    // filter_submit_btn.addEventListener('click', () => {
    //     collection_grid.classList.add("loading")
    //     filter_form.submit()
    // })

    // reset_filter_btn.addEventListener('click', () => {
    //     collection_grid.classList.add("loading")
    // })

    const filter_inputs = document.querySelectorAll('#submit_filters');
    const filter_reset_inputs = document.querySelectorAll('.reset-filters');
    const filter_form = document.querySelector('.filter-container');
    const reset_filter = document.querySelector('#reset-filters');
    const collection_grid = document.querySelector('.collection-grid');

    filter_inputs.forEach(input => {
        input.addEventListener('click', () => {
            collection_grid.classList.add("loading")
            filter_form.submit()
        })
    })

    // filter_reset_inputs.forEach(input => {
    //     input.addEventListener('click', () => {
    //         collection_grid.classList.add("loading")
    //     })
    // })

    // reset_filter.addEventListener('click', () => {
    //     collection_grid.classList.add("loading")
    // })

    filter_reset_inputs.forEach(input => {
        input.addEventListener('click', () => {
            collection_grid.classList.add("loading")
            filter_form.submit()
        })
    })

    // Column Toggle Functionality
    const toggleBtn = document.querySelector('#column-toggle .toggle-btn');
    const collectionGrid = document.querySelector('.collection-grid');
    
    if (toggleBtn && collectionGrid) {
      // Set initial state (default 2 columns)
      collectionGrid.classList.add('columns-2');
      
      toggleBtn.addEventListener('click', function() {
        const currentColumns = this.getAttribute('data-columns');
        
        if (currentColumns === '2') {
          // Switch to 1 column
          collectionGrid.classList.remove('columns-2');
          collectionGrid.classList.add('columns-1');
          this.setAttribute('data-columns', '1');
          this.setAttribute('aria-label', 'Switch to 2 columns');
          this.classList.add('active');
          
          // Update icon to single column
          this.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="8" y="3" width="8" height="5"/><rect x="8" y="10" width="8" height="5"/><rect x="8" y="17" width="8" height="4"/></svg>';
        } else {
          // Switch to 2 columns
          collectionGrid.classList.remove('columns-1');
          collectionGrid.classList.add('columns-2');
          this.setAttribute('data-columns', '2');
          this.setAttribute('aria-label', 'Switch to 1 column');
          this.classList.remove('active');
          
          // Update icon to double column
          this.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>';
        }
      });
    }
})